export default "__VITE_ASSET__DNSA0lrC__"